import React, { JSX, ReactElement } from 'react';
import {
    Edit,
    SimpleForm,
    required,
    SelectInput,
    ReferenceInput,
    TextInput,
    DateInput,
    ReferenceManyField,
    Datagrid,
    SimpleFormIterator,
    DateField, TextField, FormDataConsumerRenderParams, FormDataConsumer,
    ReferenceArrayInput,
    AutocompleteArrayInput,
    BooleanField,
    EditButton,
    Pagination
} from 'react-admin';
import {
    Grid,
    Box,
    Button
} from '@mui/material';
import { useActiveStatus, mysteryShopperStatus, mysteryShopperTypes, mysteryShopperChannels } from "../../defaults/defaults";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

const MysteryShopperEditResultsEmpty: () => JSX.Element = (): JSX.Element => {
    return (
        <Box sx={ {
            width: '100%',
            height: '300px',
            border: '1px solid', borderColor: 'divider',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        } }>
            <span>{ "No Results Found..." }</span>
        </Box>
    );
}

export const MysteryShopperEdit: () => JSX.Element = (): JSX.Element => {

    return (
        <Edit >
            <SimpleForm>
                <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                    <Grid size={ 6 }>
                        <TextInput name="name" source="name" validate={[required()]} fullWidth />
                        <SelectInput
                            source="status"
                            choices={ mysteryShopperStatus }
                        />
                        <SelectInput
                            source="channel"
                            choices={ mysteryShopperChannels }
                        />
                        <TextInput readOnly name="msCode" source="msCode" fullWidth />
                        <ReferenceInput
                            label="company"
                            source="company"
                            reference="companies"
                        >
                            <SelectInput optionText="name"/>
                        </ReferenceInput>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "Created" }</span>
                            <DateField showTime source="createdAt"  />
                        </Box>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "Updated" }</span>
                            <DateField showTime source="updatedAt"   />
                        </Box>
                    </Grid>
                    <Grid size={ 6 }>
                        <SelectInput name="type" source="type" validate={[required()]} fullWidth choices={ mysteryShopperTypes } />
                        <TextInput name="formUrl" source="formUrl" fullWidth />
                        <DateInput source="startDate"  />
                        <DateInput source="endDate"  />
                        <FormDataConsumer<{ type: string }>>
                            {({
                                  formData,
                                  scopedFormData,
                                  ...rest
                              }: FormDataConsumerRenderParams<{ type: string }>): ReactElement|null => {
                                if (formData?.type?.toLowerCase() === 'customer') {
                                    return (
                                        <Box sx={ {
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        } } >
                                            <h3>{ "Mystery Shopper Targets" }</h3>
                                            <ReferenceArrayInput source="customerTargets" reference="employees">
                                                <AutocompleteArrayInput />
                                            </ReferenceArrayInput>
                                        </Box>
                                    );
                                }
                                return null;
                            } }
                        </FormDataConsumer>
                        <ReferenceManyField source="mysteryShopperResults"
                                            pagination={ <Pagination /> }
                                            perPage={ 10 }
                                            empty={ <MysteryShopperEditResultsEmpty /> }
                                            emptyText={"No Results Found."}
                                            reference="mystery_shopper_results" target="id" >
                            <Datagrid bulkActionButtons={ false }>
                                <TextField source="id" />
                                <EditButton />
                            </Datagrid>
                        </ReferenceManyField>
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}